import React, { useEffect, useState } from 'react';
import { Provider, useSelector } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { BrowserRouter as Router, Redirect, Route } from 'react-router-dom';
import { ConfigProvider, Spin } from 'antd';
import store from './redux/store';
import Admin from './routes/admin';
import Auth from './routes/auth';
import './static/css/style.css';
import config from './config/config';
import 'antd/dist/antd.less';
import { socketClient } from './utility/SocketClient';
import { AuthProvider, useAuth } from './context/auth.context';
import { NotificationProvider } from './context/notification.context';
import UnifiedCallInterface from './components/ActiveCallInterface/ActiveCallInterface';
// Make socket available globally for WebRTC calling
window.socketClient = socketClient;


const { theme } = config;

const ProviderConfig = () => {
    const { rtl, topMenu, darkMode } = useSelector((state) => {
        return {
            darkMode: state.ChangeLayoutMode.data,
            rtl: state.ChangeLayoutMode.rtlData,
            topMenu: state.ChangeLayoutMode.topMenu,
        };
    });
    const { isAuthenticated, isLoaded } = useAuth();
    socketClient.on('connect', () => {
        console.log('Connected', socketClient.id);
        window.socket = socketClient; // Make socket globally available
    });
    
    socketClient.on('disconnect', () => {
        console.log('Socket disconnected');
        window.socket = null;
    });

    const [path, setPath] = useState(window.location.pathname);
    useEffect(() => {
        let unmounted = false;
        if (!unmounted) {
            setPath(window.location.pathname);
        }
        // eslint-disable-next-line no-return-assign
        return () => (unmounted = true);
}, [setPath]);

    return (
        <ConfigProvider direction={rtl ? 'rtl' : 'ltr'}>
            <ThemeProvider theme={{ ...theme, rtl, topMenu, darkMode }}>
                {!isLoaded ? (
                    <div className="spin">
                        <Spin />
                    </div>
                ) : (
                    <Router>
                        {!isAuthenticated ? <Auth /> : <Route path="/admin" component={Admin} />}
                        {isAuthenticated && !path.startsWith('/admin') && <Redirect to="/admin" />}
                        {isAuthenticated && <UnifiedCallInterface />}
                    </Router>
                )}
            </ThemeProvider>
        </ConfigProvider>
    );
};

function App() {
    return (
        <Provider store={store}>
            <NotificationProvider>
                <AuthProvider>
                    <ProviderConfig />
                </AuthProvider>
            </NotificationProvider>
        </Provider>
    );
}

export default App;
